import { Route, Routes } from 'react-router-dom';
import './App.css';
import PatientSignUp from './Container/PatientSignUp/PatientSignUp';
import PatientRoutes from './Utils/AppRoutes/PatientRoutes/PatientRoutes';
import ProviderRoutes from './Utils/AppRoutes/ProviderRoutes/ProviderRoutes';
import ForgotPassword from './Container/Logins/ForgotPassword';
import PatientLogin from './Container/Logins/PatientLogin';
import ProviderLogin from './Container/Logins/ProviderLogin';
import PatientRouteAccess from './Utils/AppRoutes/PatientRoutes/PatientRouteAccess';
import PatientViewProviderRoutes from './Utils/AppRoutes/ProviderRoutes/PatientViewProviderRoutes';
import AppointmentDetailsRoutes from './Utils/AppRoutes/ProviderRoutes/AppointmentDetailsRoutes';
import WebSiteROutes from './Utils/AppRoutes/WebSiteRoutes/WebSiteROutes';
import NewWebsiteRoutes from './Utils/AppRoutes/NewWebsiteRoutes/NewWebsiteRoutes';

function App() {
  return (
    <div className="App">
     <Routes>
        <Route path="/*" element={<NewWebsiteRoutes/>} />
        {/* <Route path="/patient-login" element={<PatientLogin />} /> */}
        {/* <Route path="/sign-up" element={<PatientSignUp/>} /> */}
        <Route path="/provider/*" element={<ProviderRoutes />} />
        <Route path="/provider/patient/*" element={<PatientViewProviderRoutes />} />
        <Route path="/provider/appointment/*" element={<AppointmentDetailsRoutes />} />
        <Route path="/patient/*" element={<PatientRouteAccess element={<PatientRoutes />} />}/>

        {/* <Route path="/provider-emr-login" element={<ProviderLogin />} /> */}
</Routes>
    </div>
  );
}

export default App;
